import './NavItems.css';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

const NavItems = () => {

    let find = window.location.search;
    let params = new URLSearchParams(find);
    let categoryQuery = params.get('category');
    console.log(categoryQuery);

    const changeActiveNav = (queryURL) => {
        if(queryURL)
        document.getElementById(queryURL+"-nav").classList.add("active-nav")
        else 
        document.getElementById("allitems-nav").classList.add("active-nav")
    }

    const history = useHistory();

    const handleLocalProductClick = () => {
        history.push("/explore?category=localproduct");
        history.go(0);
    }

    const handleElectronicClick = () => {
        history.push("/explore?category=electronic");
        history.go(0);
    }

    const handleSportClick = () => {
        history.push("/explore?category=sport");
        history.go(0);
    }

    const handleFashionClick = () => {
        history.push("/explore?category=fashion");
        history.go(0);
    }

    const handlePropertyClick = () => {
        history.push("/explore?category=properties");
        history.go(0);
    }

    const handleOthersClick = () => {
        history.push("/explore?category=others");
        history.go(0);
    }

    useEffect(() => {
        changeActiveNav(categoryQuery);
    }, [])

    return (
        <div className="bottom-navbar-container">
                <a id="allitems-nav" className="bottom-navbar-items">Semua</a>
                <a id="localproduct-nav" onClick={handleLocalProductClick} className="bottom-navbar-items">Produk Lokal</a>            
                <a id="electronic-nav" onClick={handleElectronicClick} className="bottom-navbar-items">Elektronik</a>
                <a id="sport-nav" onClick={handleSportClick} className="bottom-navbar-items">Olahraga</a>
                <a id="fashion-nav" onClick={handleFashionClick} className="bottom-navbar-items">Pakaian</a>
                <a id="properties-nav" onClick={handlePropertyClick} className="bottom-navbar-items">Properti</a>
                <a id="others-nav" onClick={handleOthersClick} className="bottom-navbar-items">Lainnya</a>
        </div>
    )
};

export default NavItems;